import { Tooltip } from '@/components/primitives/Tooltip'
import { InfoOutlined } from '@mui/icons-material'
import { Checkbox, FormControlLabel, Stack } from '@mui/material'

import { useController } from '../../hooks/useController'
import { useControllerActions } from '../../hooks/useControllerActions'
import { useTexts } from '../../useTexts'

import { TargetRangeRadio } from './TargetRangeRadio/TargetRangeRadio'
import { WarningCard } from './WarningCard'

export function Body() {
  const handlers = useControllerActions()
  const {
    data: { mode, targetRange, ordersDistribution, pairedOrders, deleteAlsoPaired, selectedOrders },
  } = useController()
  const texts = useTexts()

  return (
    <Stack gap={3}>
      {ordersDistribution === 'recurrent' || ordersDistribution === 'mixed' ? (
        <TargetRangeRadio
          mode={mode}
          value={targetRange}
          onChange={handlers.onChangeTargetRange}
          ordersDistribution={ordersDistribution}
          selectedOrders={selectedOrders}
        />
      ) : null}
      {pairedOrders && pairedOrders.length > 0 && (
        <Tooltip
          title={texts.deleteAlsoTooltip(selectedOrders[0].orderStepType)}
          disabled={mode === 'bulk'}
          placement="bottom"
        >
          <FormControlLabel
            control={
              <Checkbox checked={deleteAlsoPaired} onChange={handlers.onDeleteAlsoPairedChange} />
            }
            label={
              <Stack direction="row" spacing={1}>
                <span>
                  {mode === 'bulk'
                    ? texts.deleteAlsoBulk
                    : texts.deleteAlso(selectedOrders[0].orderStepType)}
                </span>
                <InfoOutlined />
              </Stack>
            }
          />
        </Tooltip>
      )}
      <WarningCard />
    </Stack>
  )
}
